import { DropdownMenuTrigger } from "@radix-ui/react-dropdown-menu"
import { Settings2 } from "lucide-react"
import { Table } from "@tanstack/react-table"

import { Button } from "components/ui/button"
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "components/ui/dropdown-menu"

interface DataTableViewOptionsProps<TData> {
  table: Table<TData>
}

export function DataTableViewOptions<TData>({
  table,
}: DataTableViewOptionsProps<TData>) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className="ml-auto hidden h-8 lg:flex"
        >
          <Settings2 className="mr-2 h-4 w-4" />
          View
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[150px]">
        <DropdownMenuLabel>Toggle columns</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {table
          .getAllColumns()
          .filter(
            (column) =>
              typeof column.accessorFn !== "undefined" && column.getCanHide()
          )
          .map((column) => {
            // Create a mapping for better column names
            const getColumnDisplayName = (columnId: string) => {
              const columnNameMap: Record<string, string> = {
                'cn_number': 'CN Number',
                'cn_date': 'CN Date',
                'consignor': 'Consignor',
                'consignee': 'Consignee',
                'origin': 'Origin',
                'destination': 'Destination',
                'edd': 'EDD',
                'arrival_date': 'Arrival Date',
                'delivery_date': 'Delivery Date',
                'status': 'Status',
                'remarks': 'Remarks',
                'actions': 'Actions'
              };
              return columnNameMap[columnId] || columnId.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
            };

            return (
              <DropdownMenuCheckboxItem
                key={column.id}
                className="capitalize"
                checked={column.getIsVisible()}
                onCheckedChange={(value) => column.toggleVisibility(!!value)}
                onSelect={(event) => {
                  // Prevent the dropdown from closing when clicking on checkbox items
                  event.preventDefault();
                }}
              >
                {getColumnDisplayName(column.id)}
              </DropdownMenuCheckboxItem>
            )
          })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
